export const MAX_PRESENTATION_DESCRIPTION_LENGTH = 500;
